module.exports = __webpack_public_path__ + "img/p-single-5.274f670d.jpg";